import { gql } from "@/__generated__/gql";

export const RISE_YIELD_SCORE_TIME_SERIES = gql(`
  query riseYieldScoreTimeSeries($orgId: ID!, $userId: ID!) {
    node(id: $userId) {
      id
      ... on Student {
        __typename
        rise {
          yieldScoreTimeSeries(organizationId: $orgId) {
            date
            value
            index
          }
        }
      }
    }
  }
`);
